import React from "react";
import "./Welcome.css";

const Welcome = () => {
    return (
        <div className="box right landing-box">
            <section className="box-desc landing-section" id="Welcome">
                <div className="landing-hero">
                    <div>
                        <p className="landing-eyebrow">Web Developer & Product Builder</p>
                        <h2>Aplikasi bisnis yang siap membantu operasional toko lebih rapi.</h2>
                        <p className="landing-summary">
                            Saya Budi Prasetyo, berpengalaman membangun aplikasi untuk
                            toko elektronik, sembako, dan kebutuhan operasional bisnis.
                            Produk utama saya adalah aplikasi Point of Sales & Inventory
                            yang menggabungkan transaksi, stok, barcode, dan laporan.
                        </p>
                        <div className="landing-actions">
                            <a
                                className="landing-primary-button"
                                href="https://wa.me/6282242116118?text=Halo%20Budi%2C%20saya%20ingin%20meminta%20link%20demo%20Aplikasi%20Point%20of%20Sales%20%26%20Inventory."
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Minta Link Demo
                            </a>
                            <a className="landing-secondary-button" href="/product">
                                Lihat Product
                            </a>
                        </div>
                    </div>

                    <div className="landing-preview">
                        <img
                            src="assets/product/8.PNG"
                            alt="Preview aplikasi Point of Sales dan Inventory"
                        />
                    </div>
                </div>

                <div className="landing-highlights">
                    <div>
                        <strong>POS</strong>
                        <span>Transaksi kasir cepat dan terkontrol.</span>
                    </div>
                    <div>
                        <strong>Inventory</strong>
                        <span>Monitoring stok, min/max, dan barang reject.</span>
                    </div>
                    <div>
                        <strong>Dashboard</strong>
                        <span>Laporan penjualan, hutang, dan grafik performa.</span>
                    </div>
                    <div>
                        <strong>Barcode</strong>
                        <span>Cetak label barcode langsung dari aplikasi.</span>
                    </div>
                </div>

                <div className="landing-contact">
                    <span>Email: budi.kerja8@gmail.com</span>
                    <span>WhatsApp: 082242116118</span>
                </div>
            </section>
        </div>
    )
}

export default Welcome;
